import React, { useCallback, useMemo } from 'react';
import { useActions } from '../../../hooks/useActions';
import { useInViewEffect } from 'react-hook-inview';
import firebase from 'firebase/app';

import { ReactComponent as UploadPortfolioIcon } from './../../postCreationForm/firstPage/upload-portfolio-icon.svg';
import { ReactComponent as BriefIcon } from './../../postCreationForm/firstPage/brief-icon.svg';
import { postsPages } from '../../projectSubCategory/SubCategory';
import { markPostAsRead } from '../../../firebase/api/post';
import { useSelector } from '../../../hooks/useSelector';
import classNames from 'classnames';

const POSTS_COLLECTION_NAME = 'posts';

const PostBody = ({
    page,
    invitationsPostIds,
    publishedPostIds,
    postId,
    email,
    responseEmails,
    isDeletedByAdmin,
    briefLink,
    title,
    description,
    isProjectPostPage,
    postContentWrapperClassNames,
    openPortfolioPopup,
}) => {
    const { viewPost, readPost } = useActions();
    const { user } = useSelector(state => state.authUserInfo);

    const viewUnreadPublishedPost = useCallback(
        async postId => {
            await markPostAsRead(postId);
            readPost(postId);
        },
        [readPost]
    );

    const briefLinkClass = classNames({
        'brief-link-wrap': true,
        'is-project-post-page': isProjectPostPage,
    });

    const uploadPortfolioClass = classNames({
        'upload-portfolio-btn-wrap': true,
        'is-project-post-page': isProjectPostPage,
    });

    const hasPublishedPostIdsNotification = useMemo(() => {
        return publishedPostIds && (publishedPostIds || []).includes(postId);
    }, [publishedPostIds, postId]);

    const viewInvitationPost = useCallback(
        async postId => {
            const postSnap = await firebase
                .firestore()
                .collection(POSTS_COLLECTION_NAME)
                .doc(postId)
                .get();
            const { viewed = [], unviewed = [] } = postSnap.data();

            viewPost(postId);

            if (
                (typeof viewed[0] === 'object' || typeof viewed[0] === 'undefined') &&
                !viewed.filter(viewedUser => viewedUser.email === email).length
            ) {
                return firebase
                    .firestore()
                    .collection(POSTS_COLLECTION_NAME)
                    .doc(postId)
                    .update({
                        viewed: [
                            ...viewed,
                            {
                                name: `${user.firstName} + ${
                                    user.lastName.length ? ' ' + user.lastName : ''
                                }`,
                                firstName: user.firstName,
                                lastName: user.lastName || '',
                                email: user.email,
                                position: user.position || '',
                                uid: user.uid,
                                website: user.website || '',
                            },
                        ],
                        unviewed: unviewed.filter(unviewedUser => unviewedUser.email !== email),
                    });
            }
        },
        [email, invitationsPostIds]
    );

    const hasInvitationsPostIdsNotification = useMemo(() => {
        return invitationsPostIds && (invitationsPostIds || []).includes(postId);
    }, [invitationsPostIds, postId]);

    const ref = useInViewEffect(
        ([entry]) => {
            if (entry.isIntersecting && hasInvitationsPostIdsNotification) {
                viewInvitationPost(postId);
            } else if (
                entry.isIntersecting &&
                isProjectPostPage &&
                page === postsPages.published &&
                hasPublishedPostIdsNotification
            ) {
                viewUnreadPublishedPost(postId);
            }
        },
        { threshold: 0.5 }
    );

    const handleClickNotion = e => {
        e.stopPropagation();
    };

    const postDescriptionClass = classNames({
        'post-description': true,
        'hidden-overflow': !isProjectPostPage,
    });

    const showUploadPortfolioBtn = useMemo(
        () =>
            // isProjectPostPage &&
            !responseEmails.find(
                review => review.email === email && review.response === 'decline'
            ) && page === postsPages.invited,
        // !reviewsData.find(review => review.publisherEmail === email)?.portfolioData,
        [page, responseEmails, email]
    );

    const handleUploadPortfolio = useCallback(
        e => {
            e.stopPropagation();
            openPortfolioPopup();
        },
        [openPortfolioPopup]
    );

    return (
        <div className={postContentWrapperClassNames}>
            <div className="post-body" ref={ref}>
                <div className="post-title-wrap">
                    <h2 className="post-title">{title}</h2>
                    {/* <div className="post-config-btns-wrap">
                        {showUploadPortfolioBtn && (
                            <div className={uploadPortfolioClass} onClick={handleUploadPortfolio}>
                                <UploadPortfolioIcon className="upload-portfolio-icon-post" />
                                {isProjectPostPage && (
                                    <span className="upload-portfolio-title-post">Upload</span>
                                )}
                            </div>
                        )}
                        {!!briefLink.length && (
                            <a
                                className={briefLinkClass}
                                target="_blank"
                                rel="noopener noreferrer"
                                href={briefLink}
                                onClick={handleClickNotion}
                            >
                                <BriefIcon className="brief-icon-post" />
                                {isProjectPostPage && (
                                    <span className="brief-title-post">Brief</span>
                                )}
                            </a>
                        )}
                    </div> */}
                </div>
                <div className={postDescriptionClass}>{description}</div>
            </div>
        </div>
    );
};

export default PostBody;
